// extracted by mini-css-extract-plugin
export default {"infoSection":"infoSection__ZTQ5M","icon":"icon__MTdhN"};